export const meta = [
  {
    key: 'allset',
    name: 'Allset',
    appname: 'ALLSET',
    color: 'cyan',
    category: 'Order Ahead',
    categoryKey: 'orderahead',
    excerpt:
      'Order ahead for no-contact pickup at local restaurants and coffee shops in your city. ',
    summary:
      'Find what you crave easy and fast with clear and on-point item descriptions and thoughtfully selected, highly customizable meal options.',
    support: null,
    stage: 1,
    disableToggle: false,
  },
  {
    key: 'ritual',
    name: 'Ritual',
    appname: 'RITUAL',
    category: 'Order Ahead',
    categoryKey: 'orderahead',
    color: 'cyan',
    excerpt:
      'Social ordering from your favourite local restaurants and coffee shops.',
    summary:
      'Ritual is a "social ordering" app that allows users to place an order for a meal and have it ready for pickup at a local restaurant.',
    support: null,
    stage: 1,
    disableToggle: false,
  },
  {
    key: 'doordash',
    name: 'DoorDash',
    appname: 'DOORDASH',
    category: 'Online Food Ordering',
    categoryKey: 'online',
    color: 'geekblue',
    excerpt: 'Feature your business on DoorDash and reach new customers.',
    summary:
      'DoorDash serves by delivering from the restaurant to doorstep of customers who place food orders online.',
    support: '+1(855) 973-1040',
    knowledgeBase: 'Where to find my Store ID?',
    knowledgeBaseLink:
      'https://support.cuboh.com/en/articles/5442866-where-to-find-your-doordash-store-id',
    disableToggle: false,
    publicStoreUrl: 'https://doordash.com/store/',
    tip: 'To update your DoorDash store id please reach out to the Cuboh Support team.',
    checkboxText:
      'By clicking this checkbox you are verifying that this is the correct store id of your DoorDash restaurant',
  },
  {
    key: 'eatstreet',
    name: 'EatStreet',
    appname: 'EATSTREET',
    category: 'Online Food Ordering',
    categoryKey: 'online',
    color: 'geekblue',
    excerpt:
      'EatStreet offers restaurants custom websites, mobile apps, Facebook ordering, and digital marketing services.',
    summary:
      'An American online food ordering service that acts as a centralized marketplace, where diners can order delivery and takeout.',
    support: '+1(866) 612-7021',
    stage: 0,
    disableToggle: false,
  },
  {
    key: 'grubhub',
    name: 'Grubhub',
    appname: 'GRUBHUB',
    category: 'Online Food Ordering',
    categoryKey: 'online',
    color: 'geekblue',
    excerpt:
      'No upfront costs or activation fees–ever. Complimentary tablet for managing order and powerful marketing tools.',
    summary:
      'Grubhub is a leading online and mobile food-ordering and delivery marketplace with the largest network of restaurant partners.',
    support: '+1(877) 799-0790',
    stage: 1,
    disableToggle: false,
  },
  {
    key: 'skip',
    name: 'SkipTheDishes',
    appname: 'SKIP',
    category: 'Online Food Ordering',
    categoryKey: 'online',
    color: 'geekblue',
    excerpt: 'a Canadian online restaurant ordering and food delivery company',
    summary:
      'Skip lets you easily find and order food from your favourite restaurants, so you can get back to your busy life.',
    support: '+1(855) 200-7547',
    stage: 1,
    disableToggle: false,
  },
  {
    key: 'moduurn',
    name: 'Moduurn',
    appname: 'MODUURN',
    category: 'Branded Online Ordering',
    categoryKey: 'online',
    color: 'geekblue',
    excerpt:
      'Moduurn is Simple and Easy to Use, Helping You Get Launched Quickly and Effectively',
    summary:
      'Moduurn is Simple and Easy to Use, Helping You Get Launched Quickly and Effectively',
    stage: 0,
    disableToggle: false,
  },
  {
    key: 'ubereats',
    name: 'Uber Eats',
    appname: 'UBEREATS',
    category: 'Online Food Ordering',
    categoryKey: 'online',
    color: 'geekblue',
    excerpt: 'Partner with Uber Eats and do more for your restaurant.',
    summary:
      'Uber Eats is a food delivery platform that makes getting great food from your favorite local restaurants as easy as requesting a ride.',
    support: '+1(833) 275-3287',
    tip: 'Your 4-digit pin was provided to you in the same email that your normal credentials were given.',
    officialProcess:
      'When connecting, a page will open and close automatically to ensure proper connection to the Uber Eats manager. Please log in with your UberEats tablet credentials after the full redirect process is complete',
    stage: 0,
    disableToggle: false,
    officialOnboarding:
      'Your account has been connected but is not currently active. To activate, please publish a menu to your Uber Eats account from Cuboh',
  },
  {
    key: 'chownow',
    name: 'ChowNow',
    appname: 'CHOWNOW',
    category: 'Branded Online Ordering',
    categoryKey: 'branded',
    color: 'blue',
    excerpt:
      'Grow your margins, customer relationships, and sales with commission-free online ordering powered by ChowNow.',
    summary:
      'ChowNow is a commission-free online ordering system and food ordering app helping restaurants feed their hungry customers.',
    support: '+1(888) 707-2469',
    stage: 1,
    disableToggle: true,
  },
  {
    key: 'mixbowl',
    name: 'Mixbowl',
    appname: 'Mixbowl',
    category: 'Branded Online Ordering',
    categoryKey: 'branded',
    color: 'blue',
    excerpt: 'Commission FREE ordering and delivery service.',
    summary:
      'A powerful online restaurant ordering system that enables your customers to place orders from your website and social media.',
    disableToggle: false,
  },
  {
    key: 'freshbytes',
    name: 'FreshBytes',
    appname: 'FRESHBYTES',
    category: 'Branded Online Ordering',
    categoryKey: 'branded',
    color: 'blue',
    excerpt: 'Premium Mobile Ordering System For Your Restaurant',
    summary:
      "FreshBytes helps restaurants improve customer's ordering experience from restaurant own website and branded mobile ordering app. ",
    support: '+1(888) 963-7374',
    stage: 1,
    disableToggle: false,
  },
  {
    key: 'sociavore',
    name: 'Sociavore',
    appname: 'SOCIAVORE',
    category: 'Branded Online Ordering',
    categoryKey: 'branded',
    color: 'blue',
    excerpt:
      'Sociavore is an all-in-one ecommerce platform for food & beverage businesses. ',
    summary:
      'Build a beautiful restaurant website with online ordering, merchandise store, contactless table ordering, ticketing, and more.',
    setUpMessage: false,
    disableToggle: false,
  },
  {
    key: 'smoothcommerce',
    name: 'SmoothCommerce',
    appname: 'SMOOTHCOMMERCE',
    category: 'Branded Online Ordering',
    categoryKey: 'branded',
    color: 'blue',
    excerpt:
      'All-in-one digital commerce and customer marketing platform for restaurants',
    summary:
      'Smooth Commerce provides everything a restaurant needs for online and mobile ordering, delivery, loyalty, and marketing and is ideal for local multi-unit restaurants and large regional and nationwide chains.',
    disableToggle: false,
  },
  {
    key: 'flipdish',
    name: 'Flipdish',
    appname: 'FLIPDISH',
    category: 'Branded Online Ordering',
    excerpt:
      'All-in-one digital commerce and customer marketing platform for restaurants',
    summary:
      'Smooth Commerce provides everything a restaurant needs for online and mobile ordering, delivery, loyalty, and marketing and is ideal for local multi-unit restaurants and large regional and nationwide chains.',
  },
];
